var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "forgot-password-form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onFormSubmit($event)
        }
      }
    },
    [
      _vm.resetSucceeded !== true
        ? [
            _c("tg-form-input-text", {
              attrs: {
                type: "email",
                name: "username",
                label: _vm._f("capitalize")(_vm.$t("general.email")),
                required: true,
                validation: _vm.$v.username
              },
              model: {
                value: _vm.username,
                callback: function($$v) {
                  _vm.username = $$v
                },
                expression: "username"
              }
            }),
            _vm._v(" "),
            _vm.errorMessage
              ? _c("p", {
                  staticClass: "text-body-2 text--error",
                  domProps: { textContent: _vm._s(_vm.errorMessage) }
                })
              : _c("p", {
                  staticClass: "text-body-2",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("text.account.forgot_password_description")
                    )
                  }
                }),
            _vm._v(" "),
            _c(
              "tg-button-group",
              [
                _vm.isValid && !_vm.resetRequested
                  ? _c(
                      "tg-button",
                      {
                        attrs: { loading: _vm.isLoading },
                        on: {
                          click: function($event) {
                            _vm.onFormSubmit
                            _vm.clear
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("capitalize")(_vm.$t("general.send"))
                            ) +
                            "\n      "
                        )
                      ]
                    )
                  : _c(
                      "tg-button",
                      {
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$emit("go-to-login")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm.$t("customer.login.decline")
                              )
                            ) +
                            "\n      "
                        )
                      ]
                    ),
                _vm._v(" "),
                _c(
                  "tg-button",
                  {
                    attrs: { variant: "text" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("go-to-login")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("capitalize")(_vm.$t("general.login"))) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            )
          ]
        : [
            _c("p", {
              staticClass: "text-body-2",
              domProps: {
                textContent: _vm._s(
                  _vm.$t("customer.resetting.request.check_email")
                )
              }
            }),
            _vm._v(" "),
            _c(
              "tg-button-group",
              [
                _c(
                  "tg-button",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("go-to-login")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("capitalize")(_vm.$t("general.login"))) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "tg-button",
                  {
                    attrs: { variant: "text" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("go-to-login")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("capitalize")(_vm.$t("customer.login.decline"))
                        ) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }